export function invalidatePostalAccounting(queryClient) {
  ['postal-slips', 'postal-slips-stats', 'postal-slips-batches', 'postal-slips-integrity',
    'payments', 'invoices', 'invoice', 'invoiceEditor', 'invoicePaymentsHistory', 'customers', 'customer',
    'customerInvoices', 'customerBalance', 'customer-payments', 'customer-advances', 'advances',
    'bank-statement-rows', 'bank-statements', 'bank-statements-all', 'open-invoices-manual',
    'dashboard', 'overdue-invoices', 'outstanding-invoices', 'payment-stats']
    .forEach(key => queryClient.invalidateQueries({ queryKey: [key] }));
}

export function paymentAmountsByInvoice(payments) {
  return (payments || []).reduce((amounts, payment) => {
    amounts[payment.invoice_id] = ((amounts[payment.invoice_id] || 0) * 100 + Math.round(Number(payment.importo) * 100)) / 100;
    return amounts;
  }, {});
}
